import { useParams } from 'react-router-dom';

import { useGetPayrunAssigneeHistoryQuery } from '@xemplo/payrun-query';
import { useServerSideState } from '@xemplo/table';

import { PAYRUN_ASSIGNEE_COLUMNS } from './payrun-assignee-history.helpers';
import * as S from './payrun-assignee-history.styles';
import { PayrunAssigneeHistoryProps } from './payrun-assignee-history.types';

export function PayrunAssigneeHistory({ className }: PayrunAssigneeHistoryProps) {
  const { id } = useParams<{ id: string }>();
  const { pagination, onPaginationChange } = useServerSideState();

  const { data, isLoading } = useGetPayrunAssigneeHistoryQuery({
    payrunId: id ?? null,
  });

  const tableData = data?.result;

  return (
    <S.Table
      className={className}
      data={tableData?.rows ?? []}
      columns={PAYRUN_ASSIGNEE_COLUMNS}
      enablePagination
      manualPagination
      onPaginationChange={onPaginationChange}
      pageCount={tableData?.total_Pages}
      state={{ pagination }}
      totalRowCount={tableData?.total ?? 0}
      isLoading={isLoading}
      enableRowSelection={false}
    />
  );
}
